import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const EditIconMedium: React.FC<IconProps> = (props) => (
  <IconWrapper {...props}>
    <path d="M22 6.5 17.5 2 5.95 13.57 4.3 19.72l6.15-1.65L22 6.5Zm-11.34 9.94-1.19-1.19 9.88-9.98 1.23 1.23-9.92 9.94ZM17.5 3.41l1.15 1.15-9.88 9.98-1.19-1.19 9.92-9.94ZM5.72 18.3l1.13-4.22.02-.02 3.09 3.09-.02.02-4.22 1.13ZM22 21H2v1h20v-1Z" />
  </IconWrapper>
)

export default EditIconMedium
